import UserDetails from "./UserDetails"
import React, { useState } from 'react';
import { useUser } from "./userContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"

const Dashboard = () => {
    const { user } = useUser();
    const [request, setRequest] = useState([])
    const [orders, setorders] = useState([])
    const [approvedOrders, setApprovedOrders] = useState([]);
    const [pendingOrders, setPendingOrders] = useState([]);
    const [rejectedOrders, setRejectedOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const email = user?.email || "no email provided"
    const navigate = useNavigate()
    
    // Comprehensive dummy orders data
    const dummyOrders = [
        {
            _id: "1",
            orderNumber: "REQ-2024-001",
            Title: "Laptop Procurement for New Team",
            status: "Approved",
            createdAt: "2024-01-15T10:30:00.000Z",
            updatedAt: "2024-01-18T14:20:00.000Z",
            totalAmount: 12500,
            priority: "high",
            products: [
                { name: "MacBook Pro 16-inch", quantity: 5, price: 2500 },
                { name: "Dell XPS 15", quantity: 3, price: 2000 }
            ],
            remarks: "Approved for Q1 budget allocation",
            filenames: ["quotation.pdf", "specs.pdf"]
        },
        {
            _id: "2",
            orderNumber: "REQ-2024-002",
            Title: "Office Furniture Upgrade",
            status: "Pending",
            createdAt: "2024-01-20T09:15:00.000Z",
            updatedAt: "2024-01-20T09:15:00.000Z",
            totalAmount: 8500,
            priority: "medium",
            products: [
                { name: "Ergonomic Office Chair", quantity: 10, price: 350 },
                { name: "Standing Desk", quantity: 5, price: 500 },
                { name: "Filing Cabinet", quantity: 3, price: 300 }
            ],
            remarks: "Awaiting budget approval from finance",
            filenames: ["catalog.pdf"]
        },
        {
            _id: "3",
            orderNumber: "REQ-2024-003",
            Title: "Software Licenses Renewal",
            status: "Rejected",
            createdAt: "2024-01-10T14:45:00.000Z",
            updatedAt: "2024-01-12T11:30:00.000Z",
            totalAmount: 7200,
            priority: "high",
            products: [
                { name: "Microsoft Office 365", quantity: 25, price: 150 },
                { name: "Adobe Creative Cloud", quantity: 10, price: 345 }
            ],
            remarks: "Exceeds current software budget allocation",
            filenames: ["license_agreement.pdf", "quote.pdf"]
        },
        {
            _id: "4",
            orderNumber: "REQ-2024-004",
            Title: "Team Building Event Supplies",
            status: "Approved",
            createdAt: "2024-01-25T16:20:00.000Z",
            updatedAt: "2024-01-28T10:15:00.000Z",
            totalAmount: 3200,
            priority: "low",
            products: [
                { name: "Catering Service", quantity: 1, price: 2000 },
                { name: "Activity Materials", quantity: 1, price: 800 },
                { name: "Venue Decorations", quantity: 1, price: 400 }
            ],
            remarks: "Approved for quarterly team building",
            filenames: ["event_plan.pdf"]
        },
        {
            _id: "5",
            orderNumber: "REQ-2024-005",
            Title: "IT Security Equipment",
            status: "Pending",
            createdAt: "2024-02-01T11:00:00.000Z",
            updatedAt: "2024-02-01T11:00:00.000Z",
            totalAmount: 15600,
            priority: "high",
            products: [
                { name: "Network Firewall", quantity: 2, price: 5000 },
                { name: "Security Cameras", quantity: 8, price: 450 },
                { name: "Access Control System", quantity: 1, price: 3200 }
            ],
            remarks: "Critical security upgrade required",
            filenames: ["security_audit.pdf", "quotation.pdf"]
        },
        {
            _id: "6",
            orderNumber: "REQ-2024-006",
            Title: "Marketing Campaign Materials",
            status: "Approved",
            createdAt: "2024-01-08T13:30:00.000Z",
            updatedAt: "2024-01-12T09:45:00.000Z",
            totalAmount: 5400,
            priority: "medium",
            products: [
                { name: "Printed Brochures", quantity: 5000, price: 0.50 },
                { name: "Promotional Pens", quantity: 1000, price: 2.00 },
                { name: "Banner Stands", quantity: 5, price: 200 }
            ],
            remarks: "Approved for Q1 marketing campaign",
            filenames: ["design_mockups.pdf"]
        },
        {
            _id: "7",
            orderNumber: "REQ-2024-007",
            Title: "Training Room Equipment",
            status: "Rejected",
            createdAt: "2024-01-30T15:20:00.000Z",
            updatedAt: "2024-02-02T14:10:00.000Z",
            totalAmount: 8900,
            priority: "medium",
            products: [
                { name: "Projector", quantity: 2, price: 1200 },
                { name: "Interactive Whiteboard", quantity: 2, price: 2500 },
                { name: "Conference Speaker", quantity: 1, price: 1500 }
            ],
            remarks: "Budget reallocation required for next quarter",
            filenames: ["equipment_specs.pdf"]
        },
        {
            _id: "8",
            orderNumber: "REQ-2024-008",
            Title: "Stationery Supplies",
            status: "Pending",
            createdAt: "2024-02-05T08:45:00.000Z",
            updatedAt: "2024-02-05T08:45:00.000Z",
            totalAmount: 1200,
            priority: "low",
            products: [
                { name: "A4 Paper", quantity: 50, price: 8 },
                { name: "Ballpoint Pens", quantity: 100, price: 1.5 },
                { name: "Sticky Notes", quantity: 20, price: 3 },
                { name: "File Folders", quantity: 30, price: 2 }
            ],
            remarks: "Regular quarterly stationery replenishment",
            filenames: ["stationery_list.pdf"]
        }
    ];

    useEffect(() => {
        const admin_roles = ["admin", "procurement_officer", "human_resources", "internal_auditor", "global_admin"]
        
        const initializeDummyData = () => {
            // Filter orders based on user role for realistic simulation
            let userSpecificOrders = dummyOrders;
            
            // For non-admin users, show a subset of orders
            if (!admin_roles.includes(user?.role)) {
                userSpecificOrders = dummyOrders.filter((order, index) => index % 2 === 0); // Show every other order
            }
            
            setRequest(userSpecificOrders);
            setorders(userSpecificOrders);
            
            const approved = userSpecificOrders.filter((order) => order.status === "Approved");
            const pending = userSpecificOrders.filter((order) => order.status === "Pending");
            const rejected = userSpecificOrders.filter((order) => order.status === "Rejected");
            
            setApprovedOrders(approved);
            setPendingOrders(pending);
            setRejectedOrders(rejected);
            
            setIsLoading(false);
        };

        const fetchorder = async () => { 
            if (!user || !user.email) {
                initializeDummyData();
                return;
            }
            
            try {
                const API_URL = `${process.env.REACT_APP_API_URL}/api`
                const token = localStorage.getItem("authToken")
                const userReq = await axios.get(`${API_URL}/orders`, {
                    headers: {
                        Authorization: `Bearer ${token}`, 
                        "ngrok-skip-browser-warning": "true"
                    },
                    withCredentials: true
                });
                
                console.log("user orders for count:", userReq)
                if (Array.isArray(userReq.data)) {
                    const ordersData = userReq.data;
                    setRequest(ordersData);
                    setorders(ordersData);
                    
                    const approved = ordersData.filter((order) => order.status === "Approved");
                    const pending = ordersData.filter((order) => order.status === "Pending");
                    const rejected = ordersData.filter((order) => order.status === "Rejected");
                    
                    setApprovedOrders(approved);
                    setPendingOrders(pending);
                    setRejectedOrders(rejected);
                } else {
                    console.error("invalid data format")
                    // Fallback to dummy data
                    initializeDummyData();
                }
            } catch(err) {
                if (err.response?.status === 401 || err.response?.status === 403) {
                    navigate("/signout");
                } else {
                    console.error("error fetching orders", err)
                    // Fallback to dummy data on error
                    initializeDummyData();
                }
            } finally {
                setIsLoading(false);
            }
        };

        const fetchuserOrder = async (email) => {
            if (!user || !user.email) {
                initializeDummyData();
                return;
            }
            
            try {
                const API_URL = `${process.env.REACT_APP_API_URL}/api`
                const token = localStorage.getItem("authToken")
                const userReq = await axios.get(`${API_URL}/orders/${email}`, {
                    headers: {
                        Authorization: `Bearer ${token}`, 
                        "ngrok-skip-browser-warning": "true"
                    },
                    withCredentials: true
                });
                
                if (Array.isArray(userReq.data)) {
                    setRequest(userReq.data)
                    const ordersData = userReq.data;
                    setorders(ordersData)
                    
                    const approved = ordersData.filter((order) => order.status === "Approved");
                    const pending = ordersData.filter((order) => order.status === "Pending");
                    const rejected = ordersData.filter((order) => order.status === "Rejected");
                    
                    setApprovedOrders(approved);
                    setPendingOrders(pending);
                    setRejectedOrders(rejected);
                } else {
                    console.error("invalid data format")
                    // Fallback to dummy data
                    initializeDummyData();
                }
            } catch(err) {
                console.error("error fetching orders", err)
                // Fallback to dummy data on error
                initializeDummyData();
            } finally {
                setIsLoading(false);
            }
        };

        // Use dummy data for demonstration or when API fails
        if (process.env.NODE_ENV === 'development' || !process.env.REACT_APP_API_URL) {
            initializeDummyData();
        } else {
            if (admin_roles?.includes(user?.role)) {
                fetchorder();
            } else {
                fetchuserOrder(email);
            }
        }
    }, [user, email, navigate]);

    console.log(orders)
    const request_length = (request) => {
        return Array.isArray(request) ? request.length : 0;
    }
    
    const request_amount = request_length(request);

    if (isLoading) {
        return (
            <div className="min-h-screen bg-gray-100 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500 mx-auto"></div>
                    <p className="text-gray-600 mt-4">Loading your dashboard...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-8">
                    {user?.name && user.name.split(" ").length > 1 ? (
                        <h1 className="text-4xl font-bold text-gray-900 mb-2">
                            Welcome back, {user.name.split(" ")[1]}! 👋
                        </h1>
                    ) : (
                        <h1 className="text-4xl font-bold text-gray-900 mb-2">
                            Welcome back, {user?.name || "User"}! 👋
                        </h1>
                    )}
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Here's your request overview. You have {request_amount} total requests with ${dummyOrders.reduce((sum, order) => sum + (order.totalAmount || 0), 0).toLocaleString()} in total value.
                    </p>
                    
                    {/* Quick Stats */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6 max-w-2xl mx-auto">
                        <div className="bg-white rounded-lg p-4 shadow-sm border border-green-200">
                            <div className="text-2xl font-bold text-green-600">{approvedOrders.length}</div>
                            <div className="text-sm text-gray-600">Approved</div>
                        </div>
                        <div className="bg-white rounded-lg p-4 shadow-sm border border-yellow-200">
                            <div className="text-2xl font-bold text-yellow-600">{pendingOrders.length}</div>
                            <div className="text-sm text-gray-600">Pending</div>
                        </div>
                        <div className="bg-white rounded-lg p-4 shadow-sm border border-red-200">
                            <div className="text-2xl font-bold text-red-600">{rejectedOrders.length}</div>
                            <div className="text-sm text-gray-600">Rejected</div>
                        </div>
                    </div>
                </div>
                
                {/* User Details Component */}
                <UserDetails 
                    user={user} 
                    rejectedOrders={rejectedOrders} 
                    request_amount={request_amount} 
                    approvedOrders={approvedOrders} 
                    pendingOrders={pendingOrders} 
                />
            </div>
        </div>
    );
}

export default Dashboard;